// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2023 Netherlands eScience Center
// SPDX-FileCopyrightText: 2023 dv4all
//
// SPDX-License-Identifier: Apache-2.0

export default function MentionIcon() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4C5 3.86739 5.05268 3.74021 5.14645 3.64645C5.24021 3.55268 5.36739 3.5 5.5 3.5H10.5C10.6326 3.5 10.7598 3.55268 10.8536 3.64645C10.9473 3.74021 11 3.86739 11 4C11 4.13261 10.9473 4.25979 10.8536 4.35355C10.7598 4.44732 10.6326 4.5 10.5 4.5H5.5C5.36739 4.5 5.24021 4.44732 5.14645 4.35355C5.05268 4.25979 5 4.13261 5 4ZM5.5 6.5H10.5C10.6326 6.5 10.7598 6.44732 10.8536 6.35355C10.9473 6.25979 11 6.13261 11 6C11 5.86739 10.9473 5.74021 10.8536 5.64645C10.7598 5.55268 10.6326 5.5 10.5 5.5H5.5C5.36739 5.5 5.24021 5.55268 5.14645 5.64645C5.05268 5.74021 5 5.86739 5 6C5 6.13261 5.05268 6.25979 5.14645 6.35355C5.24021 6.44732 5.36739 6.5 5.5 6.5ZM14 1V8.5C13.9984 8.89732 13.8398 9.27789 13.5588 9.55884C13.2779 9.83979 12.8973 9.99835 12.5 10H1.5C1.10326 10 0.722669 9.84283 0.441543 9.56287C0.160418 9.28292 0.0016531 8.90299 0 8.50625V2.5C0 2.36739 0.0526784 2.24021 0.146447 2.14645C0.240215 2.05268 0.367392 2 0.5 2C0.632608 2 0.759785 2.05268 0.853553 2.14645C0.947322 2.24021 1 2.36739 1 2.5V8.5C1 8.63261 1.05268 8.75979 1.14645 8.85355C1.24021 8.94732 1.36739 9 1.5 9C1.63261 9 1.75979 8.94732 1.85355 8.85355C1.94732 8.75979 2 8.63261 2 8.5V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1ZM13 1H3V8.5C2.99995 8.67047 2.97034 8.83964 2.9125 9H12.5C12.6326 9 12.7598 8.94732 12.8536 8.85355C12.9473 8.75979 13 8.63261 13 8.5V1Z"
        fill="black"
      />
    </svg>
  )
}
